import ApiClient from './api.es6';
import Accordion from './accordion.es6';

export default class FAQList {
    constructor() {
        this.accordion = new Accordion();
        this.faqlist = document.querySelector('.js-faqlist');
        this.items = [];
        this._init();
    }

    _init() {
        this.api = new ApiClient('../api/faq.php');
        this._loadJson();
    }

    async _loadJson() {
        try {
            const json = await this.api.fetchData();
            const formattedFAQObj = this._formatJson(json);
            this._createCategoryArea(json, formattedFAQObj);

            // アコーディオンを再初期化
            this.accordion.resetEvent();
        } catch (e) {
            console.error('Failed to fetch data:', e);
        }
    }

    _formatJson(json) {
        const result = {};
        json.slice(0, -1).forEach((item) => {
            const date = new Date(item.date);
            const yearMonth = String(date.getFullYear()).slice(-2) + ('0' + (date.getMonth() + 1)).slice(-2);

            if (!result[yearMonth]) {
                result[yearMonth] = [];
            }

            result[yearMonth].unshift({
                title: item.title,
                text: item.entries[0].text,
            });
        });

        console.log('リザルト', result)
        return result;
    }

    _createCategoryArea(json, formattedFAQObj) {
        // 最後の要素（カテゴリ対応表）を取得
        const categoryListEntry = json[json.length - 1];
        const categoryEntries = categoryListEntry.entries;

        categoryEntries.forEach((entry) => {
            const dom = this._generateCategoryDom(entry.disp_order, entry.text, formattedFAQObj);
            this.faqlist.insertAdjacentHTML('beforeend', dom);
        });
    }

    _generateCategoryDom(disp_order, text, formattedFAQObj) {
        let entryHtml = '';

        if (formattedFAQObj[disp_order]) {
            entryHtml = formattedFAQObj[disp_order]
                .map(
                    (entry) => `
                <div class="faqlist__category__item">
                    <div class="faqlist__category__item__q js-acc_trigger"><h4>${entry.title}</h4></div>
                    <div class="faqlist__category__item__a js-acc"><div class="js-acc_cont">${entry.text}</div></div>
                </div>
            `
                )
                .join('');
        }

        return `
            <li class="faqlist__category" data-disp_order="${disp_order}">
                <div class="faqlist__category__head">
                    <h3 class="faqlist__category__head__txt">${text}</h3>
                </div>
                ${entryHtml}
            </li>
        `;
    }
}
